import { render } from "./RepairManualCard.vue?vue&type=template&id=6b97ebc2&scoped=true&ts=true"
import script from "./repairManualCardHelper.ts?vue&type=script&lang=ts"
export * from "./repairManualCardHelper.ts?vue&type=script&lang=ts"

import "./RepairManualCard.vue?vue&type=style&index=0&id=6b97ebc2&scoped=true&lang=scss"

import exportComponent from "D:\\tools\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b97ebc2"]])

export default __exports__